import script from "./SpendingMap.vue?vue&type=script&setup=true&lang=js"
export * from "./SpendingMap.vue?vue&type=script&setup=true&lang=js"

import "./SpendingMap.vue?vue&type=style&index=0&id=2b72be60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b72be60"]])

export default __exports__